import { observable } from 'mobx'

class Objednavka {
    @observable public id: number;
    @observable public stav: string;
    @observable public idPartDate: number;
    @observable public idPartNumber: number;

    public clone(): Objednavka {
        const newObjednavka: Objednavka = new Objednavka();
        newObjednavka.loadFromEntity(this);
        return newObjednavka;
    }

    public loadFromJSON(json: any): Objednavka {
        this.id = json.id;
        this.idPartDate = json.id_part_date;
        this.idPartNumber = json.id_part_number;
        this.stav = json.stav;
        return this;
    }

    public loadFromEntity(ent: Objednavka): Objednavka {
        this.id = ent.id;
        this.idPartDate = ent.idPartDate;
        this.idPartNumber = ent.idPartNumber;
        this.stav = ent.stav;
        return this;
    }
}

export default Objednavka;


// WEBPACK FOOTER //
// ./src/models/Objednavka.tsx